import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledCallToAction {
  theme: any;
}

export const StyledCallToAction = styled.div<IStyledCallToAction>`
  .cta__content {
    padding-left: 0;
    ${({ theme }) => theme.breakpoints.phablet`
      padding-left: ${rem(`64px`)};
    `}
  }
`;
